/*
 * @Author: Jhony Reyes 
 * @Date: 2018-04-24 11:18:03 
 * @Last Modified by: Cesar Medina
 * @Last Modified time: 2020-03-24 16:02:19
 */
import { combineEpics } from 'redux-observable';

export default combineEpics();
